module.exports = __webpack_public_path__ + "static/img/24.288c0bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/image/24.jpg
// module id = oMHB
// module chunks = 0